/* Wellpaws – Giveaway code cart guard.
   Two rails around the WPFREE- discount code:
   1) Strip the code from the cart the moment a 2nd item is added, notify.
   2) Block standard Shopify checkout submit when WPFREE- is applied and
      item_count > 1, prompt to reduce cart to one item.
   Third-party dynamic checkout buttons (Shop Pay, Apple Pay, Google Pay, PayPal)
   bypass the cart page and are the accepted residual. */

(function () {
  const CODE_PREFIX = 'WPFREE-';
  const CACHE_TTL_MS = 4000;

  let cachedCart = null;
  let cachedAt = 0;
  let processing = false;
  let toastEl = null;
  let toastTimer = null;
  let modalEl = null;

  function hasGiveawayCode(cart) {
    if (!cart || !cart.discount_codes) return false;
    return cart.discount_codes.some(function (d) {
      return d && d.code && d.code.toUpperCase().indexOf(CODE_PREFIX) === 0 && d.applicable !== false;
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  async function clearDiscount() {
    // Two-step clear: POST /cart/update.js with an empty discount removes any
    // code attached at the cart level (cart-permalink attaches this way).
    // Then GET /discount/clear kills the session cookie so a page reload
    // doesn't re-apply the same code from the browser session.
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ discount: '' })
      });
    } catch (e) {
      console.error('[wpfree guard] cart discount clear failed', e);
    }
    try {
      await fetch('/discount/clear', { credentials: 'same-origin', redirect: 'follow' });
    } catch (e) {
      // Non-fatal: session cookie may or may not have been in play.
    }
  }

  function refreshCache() {
    return fetchCart().then(function (cart) {
      cachedCart = cart;
      cachedAt = Date.now();
      return cart;
    });
  }

  function getCartSyncOrStale() {
    if (cachedCart && (Date.now() - cachedAt) < CACHE_TTL_MS) return cachedCart;
    return cachedCart; // may be null on first paint; caller handles
  }

  function injectStyles() {
    if (document.getElementById('wpfree-guard-styles')) return;
    const style = document.createElement('style');
    style.id = 'wpfree-guard-styles';
    style.textContent = [
      '.wpfree-toast{position:fixed;top:24px;left:50%;transform:translate(-50%,-8px);max-width:420px;width:calc(100% - 32px);z-index:99999;',
      'background:#000433;color:#F1ECE0;padding:16px 20px;border-radius:12px;box-shadow:0 16px 40px rgba(0,4,51,.32);',
      'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;font-size:14px;line-height:1.5;',
      'opacity:0;transition:opacity .28s ease,transform .28s ease;pointer-events:none}',
      '.wpfree-toast.is-visible{opacity:1;transform:translate(-50%,0);pointer-events:auto}',
      '.wpfree-toast__title{font-weight:600;margin-bottom:4px}',
      '.wpfree-modal-backdrop{position:fixed;inset:0;z-index:100000;background:rgba(0,4,51,.6);display:flex;align-items:center;justify-content:center;',
      'padding:24px;opacity:0;transition:opacity .24s ease;pointer-events:none}',
      '.wpfree-modal-backdrop.is-visible{opacity:1;pointer-events:auto}',
      '.wpfree-modal{background:#F1ECE0;color:#000433;max-width:460px;width:100%;padding:32px;border-radius:14px;',
      'box-shadow:0 24px 60px rgba(0,4,51,.32);font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;',
      'transform:translateY(12px) scale(.98);transition:transform .28s ease}',
      '.wpfree-modal-backdrop.is-visible .wpfree-modal{transform:translateY(0) scale(1)}',
      '.wpfree-modal__title{font-size:20px;font-weight:600;margin:0 0 12px;font-family:"Newsreader",Georgia,serif}',
      '.wpfree-modal__body{font-size:15px;line-height:1.55;margin:0 0 24px}',
      '.wpfree-modal__actions{display:flex;justify-content:flex-end;gap:12px}',
      '.wpfree-modal__button{background:#E73881;color:#F1ECE0;border:0;padding:12px 22px;border-radius:999px;font-size:15px;font-weight:500;cursor:pointer}',
      '.wpfree-modal__button:hover{filter:brightness(.95)}'
    ].join('');
    document.head.appendChild(style);
  }

  function showToast(title, body) {
    injectStyles();
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'wpfree-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    const t = document.createElement('div');
    t.className = 'wpfree-toast__title';
    t.textContent = title;
    const b = document.createElement('div');
    b.textContent = body;
    toastEl.appendChild(t);
    toastEl.appendChild(b);
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 5500);
  }

  function showBlockingModal(title, body) {
    injectStyles();
    if (!modalEl) {
      modalEl = document.createElement('div');
      modalEl.className = 'wpfree-modal-backdrop';
      modalEl.setAttribute('role', 'dialog');
      modalEl.setAttribute('aria-modal', 'true');
      document.body.appendChild(modalEl);
    }
    modalEl.innerHTML = '';
    const box = document.createElement('div');
    box.className = 'wpfree-modal';
    box.setAttribute('role', 'document');
    const h = document.createElement('h3');
    h.className = 'wpfree-modal__title';
    h.textContent = title;
    const p = document.createElement('p');
    p.className = 'wpfree-modal__body';
    p.textContent = body;
    const actions = document.createElement('div');
    actions.className = 'wpfree-modal__actions';
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wpfree-modal__button';
    btn.textContent = 'Got it';
    actions.appendChild(btn);
    box.appendChild(h);
    box.appendChild(p);
    box.appendChild(actions);
    modalEl.appendChild(box);

    const dismiss = function () { modalEl.classList.remove('is-visible'); };
    btn.addEventListener('click', dismiss);
    modalEl.addEventListener('click', function (e) { if (e.target === modalEl) dismiss(); });
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') { dismiss(); document.removeEventListener('keydown', esc); }
    });

    requestAnimationFrame(function () { modalEl.classList.add('is-visible'); btn.focus(); });
  }

  // ---- Guard 1: strip on 2nd item ------------------------------------------
  async function stripIfNeeded() {
    if (processing) return;
    processing = true;
    try {
      const cart = await refreshCache();
      if (hasGiveawayCode(cart) && cart.item_count > 1) {
        await clearDiscount();
        const fresh = await refreshCache();
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wpfree-guard', cartData: fresh });
        }
        showToast(
          'Free-product code removed',
          "You've added another item to your cart. To claim your free product, use the link in your original email."
        );
      }
    } catch (e) {
      console.error('[wpfree guard] strip failed', e);
    } finally {
      processing = false;
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'wpfree-guard') return;
      stripIfNeeded();
    });
  }

  // ---- Guard 3: strip code when the shopper leaves the giveaway funnel ----
  // Anywhere outside the giveaway page or the checkout funnel, the code is
  // stripped silently on page load. Restores itself only if the user returns
  // via the original email link (which re-applies via the cart permalink).
  function isAllowedPath(p) {
    return p === '/pages/paws-on-us' || p.indexOf('/checkout') === 0;
  }

  async function stripOnOffPath() {
    if (isAllowedPath(location.pathname)) {
      // Still prime the cache on allowed paths so guard 2 has data on first click.
      refreshCache();
      return;
    }
    try {
      const cart = await refreshCache();
      if (hasGiveawayCode(cart)) {
        await clearDiscount();
        const fresh = await refreshCache();
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wpfree-guard', cartData: fresh });
        }
      }
    } catch (e) {
      console.error('[wpfree guard] off-path strip failed', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stripOnOffPath);
  } else {
    stripOnOffPath();
  }

  // ---- Guard 2: block checkout when >1 item + code applied -----------------
  document.addEventListener('click', function (e) {
    const target = e.target;
    if (!target || !target.closest) return;
    const btn = target.closest('button[name="checkout"], [type="submit"][name="checkout"]');
    if (!btn) return;

    const cart = getCartSyncOrStale();
    // Refresh in the background so future clicks are accurate.
    refreshCache();

    if (cart && hasGiveawayCode(cart) && cart.item_count > 1) {
      e.preventDefault();
      e.stopPropagation();
      showBlockingModal(
        'Only one free item per code',
        'Your free-product code applies to a single item. Please remove items from your cart until one remains, then check out again.'
      );
    }
  }, true);
})();
